import { EAPFeature } from '.';

export const features: EAPFeature[] = [
    {
        id: 'inbox',
        name: 'Inbox',
        description: 'Never miss notifications anymore thanks to the new Inbox',
        descriptionLong: (
            <>
                <p>
                    Notifications deserve a proper place on the main menu so that users can interact with the content
                    immediately. Your manager left a comment on your objective? Take note and reply right away.
                </p>
                <p>
                    Try our clickable prototype for 1:1s and Objectives, and let us know what’s important to you and
                    your employees.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_inboxPage',
        imgSrc: require('./images/inbox.png'),
        hideIfDisabled: true,
    },
    {
        id: 'new-admin-navigation',
        name: 'Easy Admin Navigation',
        description: 'We’ll make it easier to reach all admin screens, removing the need for the "Admin Toggle Button"',
        descriptionLong: (
            <>
                <p>
                    Many customers told us that toggling the navigation from “employee” to “admin” causes too much
                    friction. We plan on removing the toggle, adding administration tabs into the feature tabs.
                </p>
                <p>
                    Take a look at the clickable Figma Prototype, and let us know if you foresee any challenges or
                    downsides.
                </p>
            </>
        ),
        type: 'clickablePrototype',
        link: 'https://www.figma.com/proto/WHLU0TF4oAtnfsRhVHOVam/consolidated-admin-screens?page-id=120%3A2622&node-id=120-2650&viewport=740%2C174%2C0.21&t=3QoxmulcsliJEQMm-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=120%3A2650',
        imgSrc: require('./images/new-admin-navigation.png'),
    },
    {
        id: 'review-outlier-detection',
        name: 'Review Outlier Detection',
        description: 'Spot statistically significant rating patterns across groups in performance reviews',
        descriptionLong: (
            <p>
                When you're managing hundreds of performance reviews, hidden bias can slip through unnoticed. Our new
                Outlier Detection feature automatically surfaces statistically significant rating patterns across groups
                — by location, tenure, gender, team, manager, and more — so you can spot fairness issues in seconds.
                Instead of manually combing through spreadsheets, you'll see exactly where ratings deviate from the
                cycle average and why it matters, backed by data science best practices.
            </p>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_reviewOverviewTableAnomaly',
        imgSrc: require('./images/review-outlier-detection.png'),
    },
];
